import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Grid, Paper, Box, Button } from '@material-ui/core'
import CircularProgress from '@material-ui/core/CircularProgress'
import Moment from 'react-moment'
import moment from 'moment'

import DailyEngagement from './DailyEngagement'
import LaunchBar from './LaunchBar'
import CompetitiveShows from './CompetitiveShows'
import { TRACKER_DAILY_ENGAGEMENT } from '../../constants/module_info'
import { withStyles } from '@material-ui/core/styles'
import { styles } from '../../classes/Styles'
import { TRACKER_LAUNCH_VIEW, TRACKER_PRE_POST_VIEW, TRACKER_TIMELINE_VIEW } from '../../constants/commons'
import DateHelpers from '../../classes/DateHelpers'

export class TrackerDailyEngagementComponent extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    screenWidth: PropTypes.number,
    trackerId: PropTypes.string,
    trackerPlan: PropTypes.object,
    trackerTimelineMetrics: PropTypes.object,
    dailyEngagementTeasersTrailers: PropTypes.object,
    updateSelectedTrackers: PropTypes.func,
    trackerAverageBenchMarkPlan: PropTypes.object,
    trackerAverageBenchMarkTimelineMetrics: PropTypes.object,
    fetchSingleTrackerPlanData: PropTypes.func.isRequired,
    fetchSingleTrackerTimeLineViewData: PropTypes.func.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
      trackerData: [],
      primarySelect: null,
      benchmarkSelect1: null,
      benchmarkSelect2: null,
      benchmarkSelect3: null,
      benchmarkSelect4: null,
      averageBenchmarkData: [],
      averageBenchmarkSelect: null,
      blueLineIndex: null,
      maxValue: 0,
      maxLaunchValue: 0,
      selectedView: TRACKER_LAUNCH_VIEW,
      selectedTrackerEntities: [],
      isAllView: true,
      launchView: true,
      timelineView: true
    }
  }

  componentDidMount () {
    if (this.props.trackerPlan.details) {
      const selectedView = this.props.trackerPlan.details.tracker_topic.default_view
      this.setState({ selectedView: selectedView})
      this.setIsAllView(this.props.trackerPlan.details.tracker_topic)
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (prevState.primarySelect !== this.state.primarySelect || prevState.benchmarkSelect1 !== this.state.benchmarkSelect1 || prevState.benchmarkSelect2 !== this.state.benchmarkSelect2 || prevState.benchmarkSelect3 !== this.state.benchmarkSelect3 || prevState.benchmarkSelect4 !== this.state.benchmarkSelect4 || prevState.averageBenchmarkSelect !== this.state.averageBenchmarkSelect) {
      const val = [
        this.state.primarySelect && this.state.primarySelect.maxValue || 0,
        this.state.benchmarkSelect1 && this.state.benchmarkSelect1.maxValue || 0,
        this.state.benchmarkSelect2 && this.state.benchmarkSelect2.maxValue || 0,
        this.state.benchmarkSelect3 && this.state.benchmarkSelect3.maxValue || 0,
        this.state.benchmarkSelect4 && this.state.benchmarkSelect4.maxValue || 0,
        this.state.averageBenchmarkSelect && this.state.averageBenchmarkSelect.maxValue || 0
      ]
      const maxVal = Math.max.apply(Math, val)
      const maxValue = maxVal <= 5 ? 5
      : Math.ceil(maxVal/10) * 10
      this.setState({ maxValue: maxValue})
    }
    if (prevProps.trackerPlan != this.props.trackerPlan && this.props.trackerPlan.details) {
      const selectedView = this.props.trackerPlan.details.tracker_topic.default_view
      this.setState({ selectedView: selectedView })
      this.setIsAllView(this.props.trackerPlan.details.tracker_topic)
      if (prevProps?.trackerPlan?.details?.tracker_topic?.tracker_id === this.props?.trackerPlan?.details?.tracker_topic?.tracker_id) {
        const selectedView = this.state.selectedView
        this.setState({ selectedView: selectedView })
      }
      if (prevProps?.trackerPlan?.details?.tracker_topic?.tracker_id !== this.props?.trackerPlan?.details?.tracker_topic?.tracker_id){
        const selectedView = this.props.trackerPlan?.details?.tracker_topic.default_view
        this.setState({ selectedView: selectedView })
      }
    }
  }

  setIsAllView = (tracker) => {
    const isAllView = !tracker.days_lookback && !tracker.launch_view_look_forward && tracker.default_view === TRACKER_TIMELINE_VIEW ? false : true
    this.setState({
      isAllView: isAllView,
      launchView: tracker.days_lookback && tracker.launch_view_look_forward ? true : false,
      timelineView: tracker.timeline_view_start_date && tracker.timeline_view_end_date ? true : false
    })
  }

  handleTrackerData = (trackerData, primarySelect, benchmarkSelect1, benchmarkSelect2, benchmarkSelect3, benchmarkSelect4, blueLineIndex, maxValue, selectedView, averageBenchmarkData, averageBenchmarkSelect) => {
    this.setState({
      trackerData: trackerData,
      primarySelect: primarySelect,
      benchmarkSelect1: benchmarkSelect1,
      benchmarkSelect2: benchmarkSelect2,
      benchmarkSelect3: benchmarkSelect3,
      benchmarkSelect4: benchmarkSelect4,
      blueLineIndex: blueLineIndex,
      maxValue: maxValue,
      selectedView: selectedView,
      averageBenchmarkData: averageBenchmarkData,
      averageBenchmarkSelect: averageBenchmarkSelect
    })
    this.updateSelectedTrackers(primarySelect, benchmarkSelect1, benchmarkSelect2, benchmarkSelect3, benchmarkSelect4)
  }

  handleEntitySelectChange = (event, index) => {
    const select = this.state.trackerData.filter(f => f.name === event.target.value)[0]
    if (select.metrics.length == 0 && event.target.value !== 'None') {
      this.props.fetchSingleTrackerPlanData(select.trackerId, select.trackerEntityId)
      this.props.fetchSingleTrackerTimeLineViewData(select.trackerId, select.trackerEntityId)
    }
    switch (index) {
      case 1:
        this.setState({ primarySelect: select })
        this.updateSelectedTrackers(select, this.state.benchmarkSelect1, this.state.benchmarkSelect2, this.state.benchmarkSelect3, this.state.benchmarkSelect4)
        break
      case 2:
        this.setState({ benchmarkSelect1: select })
        this.updateSelectedTrackers(this.state.primarySelect, select, this.state.benchmarkSelect2, this.state.benchmarkSelect3, this.state.benchmarkSelect4)
        break
      case 3:
        this.setState({ benchmarkSelect2: select})
        this.updateSelectedTrackers(this.state.primarySelect, this.state.benchmarkSelect1, select, this.state.benchmarkSelect3, this.state.benchmarkSelect4)
        break
      case 4:
        this.setState({ benchmarkSelect3: select})
        this.updateSelectedTrackers(this.state.primarySelect, this.state.benchmarkSelect1, this.state.benchmarkSelect2, select, this.state.benchmarkSelect4)
        break
      case 5:
        this.setState({ benchmarkSelect4: select})
        this.updateSelectedTrackers(this.state.primarySelect, this.state.benchmarkSelect1, this.state.benchmarkSelect2, this.state.benchmarkSelect3, select)
        break
    }
  }

  handleAverageBenchmarkSelect = (event) => {
    const select = this.state.averageBenchmarkData.filter(f => f.name === event.target.value)[0]
    this.setState({ averageBenchmarkSelect: select })
  }

  handleMaxValue = (maxValue) => {
    this.setState({ maxValue: maxValue })
  }

  handleMaxLaunchValue = (maxValue) => {
    this.setState({ maxLaunchValue: maxValue })
  }
  updateSelectedTrackers = (primary, benchmark1, benchmark2, benchmark3, benchmark4) => {
    let trackers = []
    trackers.push(primary)
    trackers.push(benchmark1)
    trackers.push(benchmark2)
    trackers.push(benchmark3)
    trackers.push(benchmark4)
    this.props.updateSelectedTrackers(trackers)
    this.setState({ selectedTrackerEntities: trackers})
  }
  handleView = (view) => {
    this.setState({ selectedView: view })
  }
  render () {
    const { classes, screenWidth, trackerPlan, trackerTimelineMetrics, trackerAverageBenchMarkPlan, trackerAverageBenchMarkTimelineMetrics } = this. props
    const xl = this.state.selectedView === TRACKER_LAUNCH_VIEW ? 11 : 12
    const sm = this.state.selectedView === TRACKER_LAUNCH_VIEW ? 10 : 12
    return (
      <Paper className={classes.paper}>
        <Grid container spacing={1} direction="column">
          <Grid item container className={classes.dailyEngagementRow}>
            <Grid item xl={10} className='cardPadding'>
              <span className={classes.cardTitle}>Daily Engagement</span>
              <OverlayTrigger overlay={<Tooltip id="tooltip">{TRACKER_DAILY_ENGAGEMENT}</Tooltip>} placement="right">
                <img className={classes.cardInfo} src="/static/images/info.png" alt="info"/>
              </OverlayTrigger>
            </Grid>
          </Grid>
          <Grid item className={classes.cardSubTitle}>Earned media engagement</Grid>
        </Grid>
        { (trackerPlan && trackerPlan.isFetching) &&
          <div className='loadingProgress'>
            <CircularProgress />
          </div>
        }
        { (trackerPlan && trackerPlan.details) &&
          <>
            <Grid container spacing={1}>
              <Grid className='dailyEngagementChartRow my-1 ml-0'>
                <CompetitiveShows
                  classes={classes}
                  screenWidth={screenWidth}
                  trackerPlan={trackerPlan}
                  trackerData={this.state.trackerData}
                  primarySelect={this.state.primarySelect}
                  benchmarkSelect1={this.state.benchmarkSelect1}
                  benchmarkSelect2={this.state.benchmarkSelect2}
                  benchmarkSelect3={this.state.benchmarkSelect3}
                  benchmarkSelect4={this.state.benchmarkSelect4}
                  averageBenchmarkData={this.state.averageBenchmarkData}
                  averageBenchmarkSelect={this.state.averageBenchmarkSelect}
                  handleEntitySelectChange={this.handleEntitySelectChange}
                  handleAverageBenchmarkSelect={this.handleAverageBenchmarkSelect}
                  trackerAverageBenchMarkPlan={trackerAverageBenchMarkPlan}
                  trackerAverageBenchMarkTimelineMetrics={trackerAverageBenchMarkTimelineMetrics}
                />
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={12} md={12} sm={12}>
                <Box className="tabWrapper">
                  <Box className="d-flex flex-wrap">
                    { this.state.launchView &&
                      <>
                        <Button variant="contained" className={this.state.selectedView === TRACKER_LAUNCH_VIEW ? 'viewBtnActive labelBtn viewBtn' : 'labelBtn viewBtn'} onClick={() => this.handleView(TRACKER_LAUNCH_VIEW)}>{TRACKER_LAUNCH_VIEW}</Button>
                        <Button variant="contained" className={this.state.selectedView === TRACKER_PRE_POST_VIEW ? 'viewBtnActive labelBtn viewBtn' : 'labelBtn viewBtn'} onClick={() => this.handleView(TRACKER_PRE_POST_VIEW)}>{TRACKER_PRE_POST_VIEW}</Button>
                      </>
                    }
                    { this.state.timelineView &&
                      <Button variant="contained" className={this.state.selectedView === TRACKER_TIMELINE_VIEW ? 'viewBtnActive labelBtn viewBtn' : 'labelBtn viewBtn'} onClick={() => this.handleView(TRACKER_TIMELINE_VIEW)}>{TRACKER_TIMELINE_VIEW}</Button>
                    }
                  </Box>
                </Box>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xl={xl} lg={xl} md={xl} sm={sm} xs={sm}>
                <Grid className={classes.dailyEngagementChartRow}>
                  <DailyEngagement
                    classes={classes}
                    screenWidth={screenWidth}
                    trackerId={this.props.trackerId}
                    trackerPlan={trackerPlan}
                    trackerTimelineMetrics={trackerTimelineMetrics}
                    trackerAverageBenchMarkPlan={trackerAverageBenchMarkPlan}
                    trackerAverageBenchMarkTimelineMetrics={trackerAverageBenchMarkTimelineMetrics}
                    trackerData={this.state.trackerData}
                    primarySelect={this.state.primarySelect}
                    benchmarkSelect1={this.state.benchmarkSelect1}
                    benchmarkSelect2={this.state.benchmarkSelect2}
                    benchmarkSelect3={this.state.benchmarkSelect3}
                    benchmarkSelect4={this.state.benchmarkSelect4}
                    averageBenchmarkData={this.state.averageBenchmarkData}
                    averageBenchmarkSelect={this.state.averageBenchmarkSelect}
                    dailyEngagementTeasersTrailers={this.props.dailyEngagementTeasersTrailers}
                    maxValue={this.state.maxValue}
                    selectedView={this.state.selectedView}
                    blueLineIndex={this.state.blueLineIndex}
                    handleTrackerData={this.handleTrackerData}
                    handleMaxValue={this.handleMaxValue}
                    selectedTrackerEntities={this.state.selectedTrackerEntities}
                  />
                </Grid>
              </Grid>
              { this.state.selectedView === TRACKER_LAUNCH_VIEW &&
                <Grid item xl={1} lg={1} md={1} sm={2} xs={2}>
                  <Grid className={classes.dailyEngagementChartRow}>
                    <LaunchBar
                      classes={classes}
                      screenWidth={screenWidth}
                      trackerPlan={trackerPlan}
                      trackerAverageBenchMarkPlan={trackerAverageBenchMarkPlan}
                      trackerData={this.state.trackerData}
                      primarySelect={this.state.primarySelect}
                      benchmarkSelect1={this.state.benchmarkSelect1}
                      benchmarkSelect2={this.state.benchmarkSelect2}
                      benchmarkSelect3={this.state.benchmarkSelect3}
                      benchmarkSelect4={this.state.benchmarkSelect4}
                      averageBenchmarkSelect={this.state.averageBenchmarkSelect}
                      handleMaxLaunchValue={this.handleMaxLaunchValue}
                      maxLaunchValue={this.state.maxLaunchValue}
                    />
                  </Grid>
                </Grid>
              }
            </Grid>
          </>
        }
      </Paper>
    )
  }
}

export class DailyEngagementOverview extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    screenWidth: PropTypes.number,
    trackerPlan: PropTypes.object
  }

  render () {
    const { trackerPlan } = this.props
    let primaryTracker = trackerPlan.details && trackerPlan.details.primary_tracker
    let primaryTotal = 0
    primaryTracker && primaryTracker.metrics.map(m => primaryTotal += m.value)
    let benchmarks = trackerPlan.details && trackerPlan.details.benchmarks
    let benchmarksTotalArray = []
    let benchmarkValue = 0
    benchmarks && benchmarks.map(b => {
      b.metrics.map(m => benchmarkValue += m.value)
      benchmarksTotalArray.push(benchmarkValue)
    })
    let benchmarksTotal = 0
    benchmarksTotalArray.map(b => benchmarksTotal += b)
    benchmarksTotal = benchmarksTotal / benchmarksTotalArray.length
    const overviewValue = (primaryTotal / benchmarksTotal) * 100
    let launchDate = trackerPlan.details.tracker_topic && trackerPlan.details.tracker_topic.launch_date
    let lookBackDays = moment(new Date()).diff(moment(new Date(launchDate)), 'days') - 2
    lookBackDays = lookBackDays > 0 ? 0 : lookBackDays
    return (
      <div className='dailyEngagementVolume'>
        <div className='dailyEngagementVolumeDiv'>
          <div className='dailyEngagementVolumeTitle'>
            {Math.round(overviewValue)}%
          </div>
          <div className='dailyEngagementVolumeSubtitle'>
            Volume vs {trackerPlan && trackerPlan.details && trackerPlan.details.tracker_topic.average_benchmark_display_name} average
          </div>
          <div className='dailyEngagementVolumeValue'>
            <span className='overviewLaunchDate'>
              {this.formatDate(trackerPlan)}
            </span>
            <span>{`${lookBackDays} days`}</span>
          </div>
        </div>
      </div>
    )
  }

  formatDate = (trackerPlan) => {
    if (trackerPlan && trackerPlan.details && trackerPlan.details.tracker_topic) {
      const premiereDate = moment(new Date(trackerPlan.details.tracker_topic.launch_date))
      if (DateHelpers.isYearEndDate(premiereDate)) {
        return (<Moment format="YYYY">{premiereDate}</Moment>)
      }
      return (<Moment format="MMM DD,YYYY">{premiereDate}</Moment>)
    }
    return null
  }
}

export default withStyles(styles)(TrackerDailyEngagementComponent)